import { useState } from 'react';

import { Button, Toggle } from '@flipster/react/design-system';
import { css } from '@flipster/styled-system/css';
import { flex, hstack } from '@flipster/styled-system/patterns';

import { getFlags, updateFlagsAndReload, type Flags } from '../../flag';

export const Flag = () => {
  const [flags, setFlags] = useState<Flags>(getFlags());
  const [dirty, setDirty] = useState<boolean>(false);

  return (
    <div className={flex({ minH: '100%', flex: 1, align: 'stretch', gap: 8 })}>
      <ul className={css({ flex: 1, px: 8, rounded: 4, bgColor: 'background.default.level-0' })}>
        {Object.entries(flags).map(([key, value]) => (
          <li className={hstack({ py: 4, gap: 8 })} key={key}>
            <span className={css({ textStyle: 'Text/L/Strong' })}>{key}:</span>
            <Toggle
              selected={value}
              onChange={() => {
                setDirty(true);
                setFlags((prevState) => ({ ...prevState, [key]: !prevState[key] }));
              }}
            />
          </li>
        ))}
      </ul>
      <Button
        hierarchy='primary'
        color='accent'
        size='small'
        label='Apply & Reload'
        disabled={!dirty}
        onClick={() => updateFlagsAndReload(flags)}
      />
    </div>
  );
};
